const ITEMS = [
  "Streetsville",
  "Meadowvale Village",
  "Levi Creek",
  "Credit Mills",
  "43.5890° N · 79.6441° W",
  "A Stronger Voice for Ward 11",
  "Listen First · Act Decisively",
];

const Marquee = ({ dark = true }) => (
  <div
    data-testid="editorial-marquee"
    className={`overflow-hidden border-y py-5 ${
      dark ? "border-pine-900 bg-pine-700 text-paper" : "border-pine-700/15 bg-parch text-pine-700"
    }`}
  >
    <div className="flex w-max animate-marquee items-center">
      {[...ITEMS, ...ITEMS].map((item, i) => (
        <span key={i} className="flex items-center whitespace-nowrap">
          <span className="px-8 font-serif text-xl italic tracking-wide sm:text-2xl">{item}</span>
          <span className={`h-1.5 w-1.5 rotate-45 ${dark ? "bg-terra-400" : "bg-terra-500"}`} />
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
